import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Portfolio = () => {
  const [portfolioImages, setPortfolioImages] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch portfolio from API
  useEffect(() => {
    const fetchPortfolio = async () => {
      try {
        const response = await axios.get(`${API}/portfolio`);
        // Sort by order field
        const sorted = response.data.sort((a, b) => (a.order || 0) - (b.order || 0));
        setPortfolioImages(sorted);
      } catch (error) {
        console.error("Error fetching portfolio:", error);
        toast.error("Erreur lors du chargement du portfolio");
      } finally {
        setLoading(false);
      }
    };
    fetchPortfolio();
  }, []);

  return (
    <div data-testid="portfolio-page">
      {/* Header */}
      <section className="page-header">
        <div className="page-container">
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4 animate-fade-in-up">
            Portfolio
          </p>
          <h1 className="page-title animate-fade-in-up animation-delay-100">
            Réalisations
          </h1>
          <p className="page-subtitle animate-fade-in-up animation-delay-200">
            Découvrez une sélection de mes créations. Chaque tatouage est unique et réalisé sur mesure.
          </p>
        </div>
      </section>

      {/* Gallery */}
      <section className="pb-24 md:pb-32">
        <div className="page-container">
          {loading ? (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="aspect-square bg-secondary animate-pulse" />
              ))}
            </div>
          ) : (
            <div className="masonry-grid">
              {portfolioImages.map((image, index) => (
                <div
                  key={image.id}
                  className="masonry-item img-hover-zoom overflow-hidden group cursor-pointer"
                  data-testid={`portfolio-image-${index}`}
                >
                  <div className="relative">
                    <img
                      src={image.image_url}
                      alt="Tatouage"
                      className="w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300" />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
